import React from 'react';
import PropTypes from 'prop-types';

import getWarningLabel from '../../utils/getWarningLabel';

import ProductLabel from 'apps/products/models/ProductLabel';
import ProductWarnings from 'apps/products/models/ProductWarnings';

const ProductWarning = ({ basketItem, className, product, productWarningsForSku }) => {
  const warningLabel = getWarningLabel(basketItem, product, productWarningsForSku);

  if (!warningLabel) {
    return null;
  }

  return (
    <span className={className}>
      {warningLabel}
    </span>
  );
};

ProductWarning.propTypes = {
  basketItem: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
  }),
  product: PropTypes.shape({
    sku: PropTypes.string.isRequired,
    labels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
  }),
  className: PropTypes.string,
  productWarningsForSku: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductWarnings))),
};

ProductWarning.defaultProps = {
  className: 'fop-row-error',
  productWarningsForSku: [],
};

export default ProductWarning;
